export const defaults = {
  transitionTime: "0.3s",
};

export default defaults;
